export var NOFOLLOW_URLS = ['/preguntas/nueva-pregunta', '/mensajes/nuevo'];
export var OBSOLETE_URLS = ['/cotizacion/', '/credentials/add', '/acciones/', '/myportfolios', '/amp/', '/joinNow', '/es/', '/en/', '/group/', '/group-signup/', '/dynamic-group-signup/', '/groups/', '/markets/overview', '/index/', '/indice-bolsa/', '/user/', '/users/', '/event/', '/grupos/invertir-en-bolsa', '/grupos/fondos-de-inversion', '/grupos/planes-de-pensiones', '/miniblog/', '/blogs/', '/mercados-financieros', '/product/', '/products/'];
export var STOREFRONT_REDIRECTS = [{
  tag: 'roboadvisors',
  to: '/usuario/Kaloxa/articulos/comparativa-roboadvisors-carteras-indexadas'
}, {
  tag: 'cuentas-ahorro',
  to: '/usuario/AsunInfante/articulos/mejores-cuentas-remuneradas'
}, {
  tag: 'depositos',
  to: '/usuario/eduardogarcia/articulos/los-mejores-depositos-bancarios-a-plazo-fijo'
}, {
  tag: 'jubilacion',
  to: '/planes-pensiones'
}, {
  tag: 'bitcoin-criptomonedas',
  to: '/usuario/Josetrecet/articulos/invertir-criptodivisas'
}, {
  tag: 'infraestructuras',
  to: '/fondos-inversion/categorias/498-Rv_sector_infraestructura'
}, {
  tag: 'seguros-ahorro',
  to: '/usuario/eduardogarcia/articulos/que-son-los-seguros-de-ahorro-y-como-funcionan'
}, {
  tag: 'invertir-primeros-ahorros',
  to: '/usuario/AsunInfante/articulos/donde-empezar-invertir-ahorros'
}, {
  tag: 'fondos-de-fondos',
  to: '/fondos-inversion'
}, {
  tag: 'aprender-a-invertir',
  to: 'https://www.finect.com/guias'
}, {
  tag: 'europa-espana',
  to: '/fondos-inversion/categoria/europa'
}, {
  tag: 'eeuu',
  to: '/fondos-inversion/categoria/estados-unidos'
}, {
  tag: 'mercados-emergentes',
  to: '/fondos-inversion/categorias/332-Rv_global_emergente'
}, {
  tag: 'inversion-global',
  to: '/fondos-inversion/categoria/globales'
}, {
  tag: 'crowd',
  to: '/usuario/santiagobaron/articulos/que-crowdlending-caracteristicas-tipos-plataformas-invertir'
}, {
  tag: 'megatendencias',
  to: '/fondos-inversion/categoria/tematicos'
}];
export var PRODUCTS_REDIRECTS = [{
  product: 'indexa-capital-roboadvisor',
  to: '/usuario/mariarefojos/articulos/indexa-capital-opiniones-y-analisis-del-roboadvisor'
}, {
  product: 'myinvestor-roboadvisor',
  to: '/usuario/mariarefojos/articulos/myinvestor-opiniones-y-analisis-del-roboadvisor'
}];